<template>
	<v-list dense rounded v-if="data">
		<v-list-item>
			<v-list-item-content>
				<p class='ml-8 caption'>Paste URL corresponding to LinkedIn article you wish to add.</p>
				<v-layout wrap>
					<v-flex grow pr-4>
						<v-text-field
							label="Linked-In News URL"
							prepend-icon="mdi-linkedin"
							@input="clearTitle"
							v-model="data.URL"
							filled
						/>
					</v-flex>
					<v-flex shrink>
						<v-btn
							large
							@click="scrape"
							tile
							:color="newsLoaded ? 'secondary' : 'primary'"
						>
							Fetch title
						</v-btn>
					</v-flex>
				</v-layout>

			</v-list-item-content>
		</v-list-item>
		<v-list-item>
				<v-list-item-content>
					<v-textarea
						class="fullwidth"
						filled
						label="Article Title"
						prepend-icon="mdi-format-header-1"
						required
						v-model="data.title"
						rows=2
					></v-textarea>
				</v-list-item-content>
			</v-list-item>

	</v-list>
</template>

<script>
const API_URL = 'https://www.ecc.no/linkedInNews'

import Messages from '@/helpers/message-helper'
import axios from 'axios'

import TextEditor from '@/components/admin/TextEditor'

export default {
	name: 'NewsFormLinkedIn',
	components: {
		TextEditor,
	},
	props: {
		data: {
			type: Object,
			default: {
				URL: '',
				title: '',
				type: ''
			},
		},
	},
	computed: {
		newsLoaded() {
			const { URL, title } = this.data
			return URL && title
		},
	},
		mounted() {
			console.info("News type", this.data.type)
		},
	methods: {
		clearTitle() {
			this.data.title = ''
		},

		async scrape() {
			const params = { URL: this.data.URL }

			try {
				const result = await axios.get(API_URL, { params })
				const { title, url } = result.data

				if (!title && !url) throw new Error('News article not found')

				this.$set(this.data, 'URL', url)
				this.$set(this.data, 'title', title)
			} catch (error) {
				throw new Error(error)
			}
		}
	},
}
</script>
